const GOLD = "#F5A623";
const GOLD_DARK = "#9A6400";
const CREAM = "#FAF7F1";
const INK = "#1A1F2E";
const INK2 = "#5A6478";
const NAVY = "#081438";
export default function AreasReviews() {
  return <section id="areas-reviews" style={{
    background: CREAM,
    position: "relative",
    overflow: "hidden"
  }}>

      {}
      <div style={{
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        width: "100%",
        display: "block"
      }}>
          <path d="M0,60 C360,0 1080,0 1440,60 L1440,0 L0,0 Z" fill={NAVY} />
        </svg>
      </div>

      {}
      <svg aria-hidden="true" style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.04,
      pointerEvents: "none",
      zIndex: 1
    }}>
        <filter id="ar-grain"><feTurbulence type="fractalNoise" baseFrequency="0.75" numOctaves="4" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#ar-grain)" />
      </svg>

      {}
      <div aria-hidden="true" style={{
      position: "absolute",
      top: "40px",
      left: "40px",
      width: "64px",
      height: "64px",
      borderTop: `2px solid ${GOLD}50`,
      borderLeft: `2px solid ${GOLD}50`,
      zIndex: 1
    }} />
      <div aria-hidden="true" style={{
      position: "absolute",
      bottom: "40px",
      right: "40px",
      width: "64px",
      height: "64px",
      borderBottom: `2px solid ${GOLD}50`,
      borderRight: `2px solid ${GOLD}50`,
      zIndex: 1
    }} />

      <div style={{
      position: "relative",
      zIndex: 2,
      maxWidth: "1280px",
      margin: "0 auto",
      padding: "clamp(56px,7vw,88px) clamp(20px,5vw,48px)"
    }}>

        {}
        <div style={{
        textAlign: "center",
        marginBottom: "44px"
      }}>
          <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          marginBottom: "16px"
        }}>
            <div style={{
            width: "32px",
            height: "2px",
            background: GOLD
          }} />
            <span style={{
            fontFamily: "Manrope,sans-serif",
            fontSize: "11px",
            fontWeight: 700,
            letterSpacing: "0.1em",
            textTransform: "uppercase",
            color: GOLD_DARK
          }}>
              Real Reviews
            </span>
            <div style={{
            width: "32px",
            height: "2px",
            background: GOLD
          }} />
          </div>
          <h2 style={{
          fontFamily: "Plus Jakarta Sans,sans-serif",
          fontWeight: 800,
          fontSize: "clamp(26px,3.5vw,42px)",
          lineHeight: 1.1,
          color: INK,
          marginBottom: "12px"
        }}>
            5.0 Stars From <span style={{
            color: GOLD_DARK
          }}>Sydney Homeowners</span>
          </h2>
          <p style={{
          fontFamily: "Manrope,sans-serif",
          fontSize: "clamp(14px,1.5vw,16px)",
          color: INK2,
          lineHeight: 1.7,
          maxWidth: "520px",
          margin: "0 auto"
        }}>
            Every review is from a verified Google customer across our service areas. No filters, no cherry-picking.
          </p>
        </div>

        {}
        {}
        <script src="https://elfsightcdn.com/platform.js" async></script>
        <div className="elfsight-app-e48a8977-4fbd-41d9-a656-6a6d33f0fcb1" data-elfsight-app-lazy></div>

        {}
        <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "24px",
        justifyContent: "center",
        marginTop: "36px"
      }}>
          {["5.0 average rating", "Verified Google reviews", "Across 217+ suburbs"].map((t, i) => <div key={t} data-index={i} style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px"
        }}>
              <span style={{
            color: GOLD_DARK,
            fontSize: "14px",
            fontWeight: 700
          }}></span>
              <span style={{
            fontFamily: "Manrope,sans-serif",
            fontSize: "13px",
            color: INK,
            fontWeight: 600
          }}>{t}</span>
            </div>)}
        </div>
      </div>

      {}
      <div style={{
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        width: "100%",
        display: "block"
      }}>
          <path d="M0,0 C360,60 1080,60 1440,0 L1440,60 L0,60 Z" fill={NAVY} />
        </svg>
      </div>
    </section>;
}